import React from 'react'
import '../CSS/style.css'

function Heading(props) {
    return (
        <div className='container-fluid text-center classEffect p-1 sticky' data-aos-duration="1000" data-aos="zoom-in" data-aos-delay="100" style={{ zIndex: 100 }}>
            <h2 style={{ color: props.color, textDecoration: "underline" }}>{props.heading}</h2>
        </div>
    )
}

export default Heading
